
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veranstaltung/[slug]",
      function () {
        return require("private-next-pages/veranstaltung/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veranstaltung/[slug]"])
      });
    }
  